export const VIEWER = 'VIEWER';
